export default "//static.tradera.net/touchweb/static/output/images/category-photo-cameras-optics.f989457f.svg";